import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
class SpecificActualCostInfo extends Component {
  
  static propTypes = {

  };

  state = {
  };

  constructor(props)
  {
    super(props);
    //bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }


  componentDidMount()
  {
  }

   getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.props.handleChange({target:{value:val.value,id:'control_account'}});
  }

  render() {
    return (
      <React.Fragment>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Control Account</InputLabel>
              <Select
              required
              id="control_account"
              name="control_account"
              value={this.getValueCatalog(this.props.control_accounts,this.props.actual_cost.control_account)}
              onChange={this.handleChangeSelection}
              options={this.props.control_accounts}
              isDisabled={this.props.reviewActive}
              error={this.props.errores.control_account}
              errorText={this.props.errores.control_account}
              helperText={this.props.errores.control_account}
              styles={{control: (provided,state) => (this.props.errores.control_account ? {...provided,borderColor: 'red', } : provided)}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Reporting Period</InputLabel>
              <Typography gutterBottom variant="h5">
              {this.props.actual_cost.reporting_number}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="account"
              name="account"
              label="Account"
              fullWidth
              autoComplete="account"
              value={this.props.actual_cost.account}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.account}
              helperText={this.props.errores.account}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="inv_number"
              name="inv_number"
              label="Inv. Number"
              fullWidth
              autoComplete="inv_number"
              value={this.props.actual_cost.inv_number}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.inv_number}
              helperText={this.props.errores.inv_number}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="company"
              name="company"
              label="Company"
              fullWidth
              autoComplete="company"
              value={this.props.actual_cost.company}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.company}
              helperText={this.props.errores.company}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="contract_number"
              name="contract_number"
              label="Contract Number"
              fullWidth
              autoComplete="contract_number"
              value={this.props.actual_cost.contract_number}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.contract_number}
              helperText={this.props.errores.contract_number}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="contract"
              name="contract"
              label="Contract"
              fullWidth
              autoComplete="contract"
              value={this.props.actual_cost.contract}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.contract}
              helperText={this.props.errores.contract}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    actual: state.actual,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecificActualCostInfo);




// WEBPACK FOOTER //
// ./src/features/actual/SpecificActualCostInfo.js